import { render } from "./ViewToggle.vue?vue&type=template&id=3a8dad81"
import script from "./ViewToggle.vue?vue&type=script&lang=js"
export * from "./ViewToggle.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__